const initialState = {
  siteSelectedRegion: null,
  siteInput: '',
  siteInputIsSegment: null,

  userId: null,
  rule: null,
  supplierCategory: null,
  supplierRegion: null,
  supplierContract: null, // esses 3 sao setados se o fornecedor seleciona uma regiao
  userType: '',
  selectedRegion: null,
  selectedEvent: null,
  firstLogin: null,
  balance: '',
  events: [],
  regions: [],
  userName: '',
  stage: '',
  count: '',
  date: '',
  eventFinished: null,
  category: null,
  token: null,
  isSupplier: null,
  isBride: null,
  isFranchise: null,

  vbs: null,
  operator: null,
  potential: null,
  contractsCount: null,
  totalContractsValue: null,
  roi: null,
  pointsBalance: null,
  supplierContracts: [],
};

export default initialState;
